module.exports = __webpack_public_path__ + "media/images/meta/admin/apple-touch-icon-prod-e02b7653411ef7a73d2a4355ec813b7b.png";